import { render, staticRenderFns } from "./Sefaz.vue?vue&type=template&id=171e2fe0&scoped=true&"
import script from "./Sefaz.vue?vue&type=script&lang=js&"
export * from "./Sefaz.vue?vue&type=script&lang=js&"
import style0 from "./Sefaz.vue?vue&type=style&index=0&id=171e2fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e2fe0",
  null
  
)

export default component.exports